<template>
<div class="Interaction padding-20 bgc box-shadow">
    <keep-alive include="InteractionList">
        <router-view></router-view>
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'SignIn',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.Interaction {
    font-family: PingFangSC-Regular,PingFang SC;
}
</style>